/**
 * ApiGest API
 * ApiGest API documentation
 *
 * OpenAPI spec version: 1.0.0
 * Contact: info@eneasys.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { OptionalOfTenantContextDTO } from '../model/optionalOfTenantContextDTO';
import { UserToContextDTO } from '../model/userToContextDTO';

import { AIG_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class UserToContextResourceService {

    protected basePath = 'https://api-gest.eneasys.net';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(AIG_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * countUsersOfContexts
     * 
     * @param contextIdEquals 
     * @param contextIdGreaterThan 
     * @param contextIdGreaterThanOrEqual 
     * @param contextIdIn 
     * @param contextIdLessThan 
     * @param contextIdLessThanOrEqual 
     * @param contextIdNotEquals 
     * @param contextIdSpecified 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param userCodeContains 
     * @param userCodeDoesNotContain 
     * @param userCodeEquals 
     * @param userCodeIn 
     * @param userCodeNotEquals 
     * @param userCodeSpecified 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public countUsersOfContextsUsingGET(contextIdEquals?: number, contextIdGreaterThan?: number, contextIdGreaterThanOrEqual?: number, contextIdIn?: Array<number>, contextIdLessThan?: number, contextIdLessThanOrEqual?: number, contextIdNotEquals?: number, contextIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, userCodeContains?: string, userCodeDoesNotContain?: string, userCodeEquals?: string, userCodeIn?: Array<string>, userCodeNotEquals?: string, userCodeSpecified?: boolean, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public countUsersOfContextsUsingGET(contextIdEquals?: number, contextIdGreaterThan?: number, contextIdGreaterThanOrEqual?: number, contextIdIn?: Array<number>, contextIdLessThan?: number, contextIdLessThanOrEqual?: number, contextIdNotEquals?: number, contextIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, userCodeContains?: string, userCodeDoesNotContain?: string, userCodeEquals?: string, userCodeIn?: Array<string>, userCodeNotEquals?: string, userCodeSpecified?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public countUsersOfContextsUsingGET(contextIdEquals?: number, contextIdGreaterThan?: number, contextIdGreaterThanOrEqual?: number, contextIdIn?: Array<number>, contextIdLessThan?: number, contextIdLessThanOrEqual?: number, contextIdNotEquals?: number, contextIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, userCodeContains?: string, userCodeDoesNotContain?: string, userCodeEquals?: string, userCodeIn?: Array<string>, userCodeNotEquals?: string, userCodeSpecified?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public countUsersOfContextsUsingGET(contextIdEquals?: number, contextIdGreaterThan?: number, contextIdGreaterThanOrEqual?: number, contextIdIn?: Array<number>, contextIdLessThan?: number, contextIdLessThanOrEqual?: number, contextIdNotEquals?: number, contextIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, userCodeContains?: string, userCodeDoesNotContain?: string, userCodeEquals?: string, userCodeIn?: Array<string>, userCodeNotEquals?: string, userCodeSpecified?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {























        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (contextIdEquals !== undefined && contextIdEquals !== null) {
            queryParameters = queryParameters.set('contextId.equals', <any>contextIdEquals);
        }
        if (contextIdGreaterThan !== undefined && contextIdGreaterThan !== null) {
            queryParameters = queryParameters.set('contextId.greaterThan', <any>contextIdGreaterThan);
        }
        if (contextIdGreaterThanOrEqual !== undefined && contextIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('contextId.greaterThanOrEqual', <any>contextIdGreaterThanOrEqual);
        }
        if (contextIdIn) {
            contextIdIn.forEach((element) => {
                queryParameters = queryParameters.append('contextId.in', <any>element);
            })
        }
        if (contextIdLessThan !== undefined && contextIdLessThan !== null) {
            queryParameters = queryParameters.set('contextId.lessThan', <any>contextIdLessThan);
        }
        if (contextIdLessThanOrEqual !== undefined && contextIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('contextId.lessThanOrEqual', <any>contextIdLessThanOrEqual);
        }
        if (contextIdNotEquals !== undefined && contextIdNotEquals !== null) {
            queryParameters = queryParameters.set('contextId.notEquals', <any>contextIdNotEquals);
        }
        if (contextIdSpecified !== undefined && contextIdSpecified !== null) {
            queryParameters = queryParameters.set('contextId.specified', <any>contextIdSpecified);
        }
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (userCodeContains !== undefined && userCodeContains !== null) {
            queryParameters = queryParameters.set('userCode.contains', <any>userCodeContains);
        }
        if (userCodeDoesNotContain !== undefined && userCodeDoesNotContain !== null) {
            queryParameters = queryParameters.set('userCode.doesNotContain', <any>userCodeDoesNotContain);
        }
        if (userCodeEquals !== undefined && userCodeEquals !== null) {
            queryParameters = queryParameters.set('userCode.equals', <any>userCodeEquals);
        }
        if (userCodeIn) {
            userCodeIn.forEach((element) => {
                queryParameters = queryParameters.append('userCode.in', <any>element);
            })
        }
        if (userCodeNotEquals !== undefined && userCodeNotEquals !== null) {
            queryParameters = queryParameters.set('userCode.notEquals', <any>userCodeNotEquals);
        }
        if (userCodeSpecified !== undefined && userCodeSpecified !== null) {
            queryParameters = queryParameters.set('userCode.specified', <any>userCodeSpecified);
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('get',`${this.basePath}/m8t/api/context-users/count`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * createUserOfContext
     * 
     * @param body UserToContextDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createUserOfContextUsingPOST(body: UserToContextDTO, observe?: 'body', reportProgress?: boolean): Observable<UserToContextDTO>;
    public createUserOfContextUsingPOST(body: UserToContextDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserToContextDTO>>;
    public createUserOfContextUsingPOST(body: UserToContextDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserToContextDTO>>;
    public createUserOfContextUsingPOST(body: UserToContextDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createUserOfContextUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserToContextDTO>('post',`${this.basePath}/m8t/api/context-users`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteUserOfContext
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteUserOfContextUsingDELETE(id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteUserOfContextUsingDELETE(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteUserOfContextUsingDELETE(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteUserOfContextUsingDELETE(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteUserOfContextUsingDELETE.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/m8t/api/context-users/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAllUsersOfContexts
     * 
     * @param contextIdEquals 
     * @param contextIdGreaterThan 
     * @param contextIdGreaterThanOrEqual 
     * @param contextIdIn 
     * @param contextIdLessThan 
     * @param contextIdLessThanOrEqual 
     * @param contextIdNotEquals 
     * @param contextIdSpecified 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param page Page number of the requested page
     * @param size Size of a page
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param userCodeContains 
     * @param userCodeDoesNotContain 
     * @param userCodeEquals 
     * @param userCodeIn 
     * @param userCodeNotEquals 
     * @param userCodeSpecified 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllUsersOfContextsUsingGET(contextIdEquals?: number, contextIdGreaterThan?: number, contextIdGreaterThanOrEqual?: number, contextIdIn?: Array<number>, contextIdLessThan?: number, contextIdLessThanOrEqual?: number, contextIdNotEquals?: number, contextIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, userCodeContains?: string, userCodeDoesNotContain?: string, userCodeEquals?: string, userCodeIn?: Array<string>, userCodeNotEquals?: string, userCodeSpecified?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<UserToContextDTO>>;
    public getAllUsersOfContextsUsingGET(contextIdEquals?: number, contextIdGreaterThan?: number, contextIdGreaterThanOrEqual?: number, contextIdIn?: Array<number>, contextIdLessThan?: number, contextIdLessThanOrEqual?: number, contextIdNotEquals?: number, contextIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, userCodeContains?: string, userCodeDoesNotContain?: string, userCodeEquals?: string, userCodeIn?: Array<string>, userCodeNotEquals?: string, userCodeSpecified?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserToContextDTO>>>;
    public getAllUsersOfContextsUsingGET(contextIdEquals?: number, contextIdGreaterThan?: number, contextIdGreaterThanOrEqual?: number, contextIdIn?: Array<number>, contextIdLessThan?: number, contextIdLessThanOrEqual?: number, contextIdNotEquals?: number, contextIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, userCodeContains?: string, userCodeDoesNotContain?: string, userCodeEquals?: string, userCodeIn?: Array<string>, userCodeNotEquals?: string, userCodeSpecified?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserToContextDTO>>>;
    public getAllUsersOfContextsUsingGET(contextIdEquals?: number, contextIdGreaterThan?: number, contextIdGreaterThanOrEqual?: number, contextIdIn?: Array<number>, contextIdLessThan?: number, contextIdLessThanOrEqual?: number, contextIdNotEquals?: number, contextIdSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, userCodeContains?: string, userCodeDoesNotContain?: string, userCodeEquals?: string, userCodeIn?: Array<string>, userCodeNotEquals?: string, userCodeSpecified?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


























        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (contextIdEquals !== undefined && contextIdEquals !== null) {
            queryParameters = queryParameters.set('contextId.equals', <any>contextIdEquals);
        }
        if (contextIdGreaterThan !== undefined && contextIdGreaterThan !== null) {
            queryParameters = queryParameters.set('contextId.greaterThan', <any>contextIdGreaterThan);
        }
        if (contextIdGreaterThanOrEqual !== undefined && contextIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('contextId.greaterThanOrEqual', <any>contextIdGreaterThanOrEqual);
        }
        if (contextIdIn) {
            contextIdIn.forEach((element) => {
                queryParameters = queryParameters.append('contextId.in', <any>element);
            })
        }
        if (contextIdLessThan !== undefined && contextIdLessThan !== null) {
            queryParameters = queryParameters.set('contextId.lessThan', <any>contextIdLessThan);
        }
        if (contextIdLessThanOrEqual !== undefined && contextIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('contextId.lessThanOrEqual', <any>contextIdLessThanOrEqual);
        }
        if (contextIdNotEquals !== undefined && contextIdNotEquals !== null) {
            queryParameters = queryParameters.set('contextId.notEquals', <any>contextIdNotEquals);
        }
        if (contextIdSpecified !== undefined && contextIdSpecified !== null) {
            queryParameters = queryParameters.set('contextId.specified', <any>contextIdSpecified);
        }
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('sort', <any>element);
            })
        }
        if (userCodeContains !== undefined && userCodeContains !== null) {
            queryParameters = queryParameters.set('userCode.contains', <any>userCodeContains);
        }
        if (userCodeDoesNotContain !== undefined && userCodeDoesNotContain !== null) {
            queryParameters = queryParameters.set('userCode.doesNotContain', <any>userCodeDoesNotContain);
        }
        if (userCodeEquals !== undefined && userCodeEquals !== null) {
            queryParameters = queryParameters.set('userCode.equals', <any>userCodeEquals);
        }
        if (userCodeIn) {
            userCodeIn.forEach((element) => {
                queryParameters = queryParameters.append('userCode.in', <any>element);
            })
        }
        if (userCodeNotEquals !== undefined && userCodeNotEquals !== null) {
            queryParameters = queryParameters.set('userCode.notEquals', <any>userCodeNotEquals);
        }
        if (userCodeSpecified !== undefined && userCodeSpecified !== null) {
            queryParameters = queryParameters.set('userCode.specified', <any>userCodeSpecified);
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UserToContextDTO>>('get',`${this.basePath}/m8t/api/context-users`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getContextsOfUserByContext
     * 
     * @param contextCode contextCode
     * @param userCode userCode
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getContextsOfUserByContextUsingGET(contextCode: string, userCode: string, observe?: 'body', reportProgress?: boolean): Observable<OptionalOfTenantContextDTO>;
    public getContextsOfUserByContextUsingGET(contextCode: string, userCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OptionalOfTenantContextDTO>>;
    public getContextsOfUserByContextUsingGET(contextCode: string, userCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OptionalOfTenantContextDTO>>;
    public getContextsOfUserByContextUsingGET(contextCode: string, userCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (contextCode === null || contextCode === undefined) {
            throw new Error('Required parameter contextCode was null or undefined when calling getContextsOfUserByContextUsingGET.');
        }

        if (userCode === null || userCode === undefined) {
            throw new Error('Required parameter userCode was null or undefined when calling getContextsOfUserByContextUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<OptionalOfTenantContextDTO>('get',`${this.basePath}/api/context-users/${encodeURIComponent(String(userCode))}/context/${encodeURIComponent(String(contextCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getUserOfContext
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUserOfContextUsingGET(id: number, observe?: 'body', reportProgress?: boolean): Observable<UserToContextDTO>;
    public getUserOfContextUsingGET(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserToContextDTO>>;
    public getUserOfContextUsingGET(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserToContextDTO>>;
    public getUserOfContextUsingGET(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getUserOfContextUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<UserToContextDTO>('get',`${this.basePath}/m8t/api/context-users/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateUserOfContext
     * 
     * @param body UserToContextDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateUserOfContextUsingPUT(body: UserToContextDTO, observe?: 'body', reportProgress?: boolean): Observable<UserToContextDTO>;
    public updateUserOfContextUsingPUT(body: UserToContextDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserToContextDTO>>;
    public updateUserOfContextUsingPUT(body: UserToContextDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserToContextDTO>>;
    public updateUserOfContextUsingPUT(body: UserToContextDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateUserOfContextUsingPUT.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UserToContextDTO>('put',`${this.basePath}/m8t/api/context-users`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
